import dynamic from 'next/dynamic'
import { Fade } from 'react-awesome-reveal'
import { useSelector } from 'react-redux'

import styles from './no-results.module.scss'
import { ComponentErrorBoundary } from '@/components/atomic/ComponentErrorBoundary'
import { InformationBanner } from '@/components/styleguide/InformationBanner'
import { constants } from '@/lib/constants'
import {
  selectAvailableVehiclePriceTags,
  selectAvailableVehicleTags,
  selectCountOfSearchParameters,
  selectRangesForManufacturers,
  selectSearchParameters,
  selectSearchTerm,
} from '@/store/selectors/search'

const AppliedFilters = dynamic(() => import('@/components/atomic/AppliedFilters'), { ssr: false })

export const NoResults = ({ isVans }) => {
  const hasSearchTerm = useSelector(selectSearchTerm)
  const searchRequest = useSelector(selectSearchParameters)
  const ranges = useSelector(selectRangesForManufacturers)
  const searchRequestCount = useSelector(selectCountOfSearchParameters)
  const vehicleTags = useSelector(selectAvailableVehicleTags)
  const vehiclePriceTags = useSelector(selectAvailableVehiclePriceTags)

  return (
    <div className={styles.container}>
      <InformationBanner>
        {hasSearchTerm
          ? constants.searchAlertMessages.withTextSearch
          : isVans
            ? constants.searchAlertMessages.vanDefault
            : constants.searchAlertMessages.carDefault}
      </InformationBanner>
      {searchRequestCount > 0 && (
        <ComponentErrorBoundary>
          <div className="search-results__applied-filters">
            <p>Search filters currently applied:</p>
            <Fade triggerOnce>
              <AppliedFilters
                filterLimit={100}
                search={{ searchRequest: searchRequest }}
                ranges={ranges}
                vehicleTags={vehicleTags}
                vehiclePriceTags={vehiclePriceTags}
                hideDefaults={true}
              />
            </Fade>
          </div>
        </ComponentErrorBoundary>
      )}
    </div>
  )
}
